import React, { useEffect, useRef } from 'react';
import { useLogout } from '../../../../hooks/useLogout';

const Logout: React.FC<React.PropsWithChildren<unknown>> = () => {
  const logout = useLogout();
  // logout() deletes the session tokens; it must run once. The effect has no
  // dependency array and StrictMode double-invokes effects in dev, so guard it
  // with a ref to avoid deleting tokens more than once.
  const hasLoggedOut = useRef(false);

  useEffect(() => {
    if (hasLoggedOut.current) {
      return;
    }
    hasLoggedOut.current = true;
    logout();
  });

  return <></>;
};

export default Logout;
